import { Dialog, DialogFooter, DialogType } from "@fluentui/react";
import { Button, Form, Input, notification, message, InputNumber } from "antd";
import FormItem from "antd/lib/form/FormItem";
import { Formik } from "formik";
import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";
import MaterialStore from "../store/materialstore";
import * as yup from "yup";
import { toJS } from "mobx";
import "../style/addchemical.css";
const materialStoreCtx = createContext(MaterialStore);

export const validationSchema = yup.object().shape({
  name: yup.string().required("Please enter a valid chemical name"),
  stock: yup.number().required("Enter opening stock value"),
});
export const AddChemical = observer(() => {
  const materialStore = useContext(materialStoreCtx);
  return (
    <Dialog
      hidden={!materialStore.showAddDialog}
      onDismiss={() => {
        materialStore.showAddDialog = false;
      }}
      dialogContentProps={{
        type: DialogType.normal,
        title: `Add ${materialStore.mainStore.assetContextName}  Chemical`,
        titleProps: { style: { fontSize: 16 } },
        subText:
          "Enter chemical name, unit of measurement,unit abbreviation and opening stock",
      }}
      modalProps={{
        isBlocking: true,
        styles: { main: { maxWidth: 450 } },
        dragOptions: true,
      }}
    >
      <Formik
        //  enableReinitialize={true}
        initialValues={toJS(materialStore.addChemicalFormData)}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          let data = {
            ...values,
            assetId: materialStore.mainStore.assetContextId,
          };
          const retVal = await materialStore.upsertChemical(data);
          console.log(retVal);
          const { action, res } = retVal;
          materialStore.chemicals.set(res.chemicalId, res);
          if (action === "added") {
            message.success("chemical added successfully");
          } else if (action === "updated") {
            message.success("chemical record updated successfully");
          }
          materialStore.showAddDialog = false;
          try {
          } catch (error) {
            notification.error({
              key: "error",
              message: "SPARS Feedback",
              description: error.message,
            });
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          setFieldValue,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form
            layout="vertical"
            labelAlign="left"
            style={{ background: "#fff", padding: "10px" }}
            onFinish={handleSubmit}
          >
            <FormItem
              label="Chemical Name"
              labelAlign="left"
              className="add-border"
              /*  help={touched.name && errors.name} */
              required
            >
              <Input name="name" value={values?.name} onChange={handleChange} />
            </FormItem>
            {materialStore.addChemicalAction === "add" && (
              <FormItem
                label="Current Stock"
                labelAlign="left"
                help={touched.stock && errors.stock}
                required
              >
                <InputNumber
                  min={0}
                  style={{ minWidth: "50%" }}
                  name="stock"
                  value={values?.stock}
                  onChange={(value) => {
                    materialStore.addChemicalFormData.stock = value;
                    setFieldValue("stock", value);
                  }}
                />
              </FormItem>
            )}
            <FormItem
              label="Quantity Unit"
              labelAlign="left"
              className="add-border"
            >
              <Input
                style={{ width: "50%" }}
                name="unit"
                value={values?.unit}
                onChange={handleChange}
              />
            </FormItem>
            <FormItem
              label="Unit Abbreviation"
              labelAlign="left"
              className="add-border"
            >
              <Input
                style={{ width: "30%" }}
                name="unitAbbr"
                value={values?.unitAbbr}
                onChange={handleChange}
              />
            </FormItem>
            <DialogFooter>
              <Button
                onClick={() => {
                  materialStore.showAddDialog = false;
                }}
                type="link"
              >
                Close
              </Button>
              <Button type="primary" htmlType="submit" loading={isSubmitting}>
                {materialStore.addChemicalAction === "add" ? "Add" : "Save"}
              </Button>
            </DialogFooter>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
});

